import type { NotificationDto, NotificationTypeKey } from "@/types/api/notifications";

function asString(value: unknown): string | null {
  return typeof value === "string" && value.length > 0 ? value : null;
}

/**
 * Build an in-app path for a notification. Returns null when params are incomplete
 * or the type is unknown.
 */
export function notificationLink(notification: NotificationDto): string | null {
  return notificationLinkForType(notification.typeKey, notification.params);
}

export function notificationLinkForType(
  typeKey: NotificationTypeKey,
  params: Record<string, unknown>,
): string | null {
  switch (typeKey) {
    case "projectReport.ready":
    case "projectReport.failed": {
      const projectId = asString(params.projectId);
      const reportId = asString(params.reportId);
      if (!projectId || !reportId) return null;
      return `/projects/${projectId}/reports?reportId=${encodeURIComponent(reportId)}`;
    }
    default: {
      const _exhaustive: never = typeKey;
      return _exhaustive;
    }
  }
}
